import { Clapperboard, Monitor, Moon, Shapes, Sun, Tv } from "lucide-react";
import { useTheme } from "next-themes";
import { Link, useNavigate } from "react-router";
import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group";

export function DisplayCard() {
  const { theme = "system", setTheme } = useTheme();
  const navigate = useNavigate();
  return (
    <Card>
      <CardHeader>
        <CardTitle>Display</CardTitle>
        <CardDescription>How the dashboard looks on this device</CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Label>Theme</Label>
          <ToggleGroup
            type="single"
            variant="outline"
            size="sm"
            value={theme}
            onValueChange={(v) => v && setTheme(v)}
          >
            <ToggleGroupItem value="light" aria-label="Light">
              <Sun /> Light
            </ToggleGroupItem>
            <ToggleGroupItem value="dark" aria-label="Dark">
              <Moon /> Dark
            </ToggleGroupItem>
            <ToggleGroupItem value="system" aria-label="System">
              <Monitor /> System
            </ToggleGroupItem>
          </ToggleGroup>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-muted/30 p-3">
          <div className="min-w-0">
            <p className="text-sm font-medium">TV mode</p>
            <p className="text-xs text-muted-foreground">
              The pixel factory floor as a 16:9 wall display. Bookmark <code className="font-mono">/tv</code>{" "}
              on a screen to open it directly.
            </p>
          </div>
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/sprites">
                <Shapes /> Sprites
              </Link>
            </Button>
            <Button variant="ghost" size="sm" asChild>
              <Link to="/easter-eggs">
                <Clapperboard /> Easter eggs
              </Link>
            </Button>
            <Button size="sm" onClick={() => navigate("/tv", { state: { from: "/settings" } })}>
              <Tv /> Open
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
